import React, { useContext, useEffect, useState } from 'react';
import { Link, useNavigate } from "react-router-dom";
import '../styles/Head.css';
import GlobalSettings from './GlobalSettings.js';
import pens from '../images/Stifte.png';
import ResultTable from './ResultTable.js';
import PageHeader from './PageHeader.js';
import PageFooter from './PageFooter.js';
import { GlobalStateContext } from './GlobalStateContext.js';

const Overview = () => {
    const {
        surveyCode,
        valid,
        surveyTitle,
        surveyName,
        answerSet,
        setAnswerSet,
        completeSet,
        token,
        participationCode,
        surveyMode,
        surveyId
    } = useContext(GlobalStateContext);

    const [state, setState] = useState({
        title: [], 
        topic: [],
        btnSend: [],  
        quest:[],
        question_id2: [], 
        nr: [],
        completeSet: [],
        surveyCompleted: false,
              
    });
    if(GlobalSettings.debugMode==='on'){
        console.log("SurMode", surveyMode);
        console.log("Answerset", answerSet);
    }
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    useEffect(() => {
        if (surveyMode) {
            setIsButtonDisabled(true);
        }
    }, [surveyMode]);
    const navigate = useNavigate();

    useEffect(() => {
      /*  fetch('/api/text')
            .then(response => response.json())
            .then(result => setState(prevState => ({
                ...prevState,
                title: result
            }))).catch(console.log);*/

        fetch('/api/quest')
            .then(response => response.json())
            .then(result => setState(prevState => ({
                ...prevState,
                quest: result
            }))).catch(console.log);

        fetch('/api/question_id2')
            .then(response => response.json())
            .then(result => setState(prevState => ({
                ...prevState,
                question_id2: result
            }))).catch(console.log); 
            
        fetch('/api/question_id')
            .then(response => response.json())
            .then(result => setState(prevState => ({
                ...prevState,
                nr: result
            }))).catch(console.log);

        fetch('/api/questions/' + surveyId)
            .then(response => response.json())
            .then(result => setState(prevState => ({
                ...prevState,
                completeSet: result
            }))).catch(console.log);

        // survey already completed?
       /* fetch('/api/surveyDone/' + participationCode)
            .then(response=>response.json())
            .then(result=> setState(prevState => ({
                ...prevState,
                surveyCompleted: result
            }))).catch(console.log); */
        if(GlobalSettings.debugMode==='on')
            console.log("PartCode", participationCode);

        if(participationCode && participationCode.length>1){
                const surveyCompletedResult = fetch('/api/surveyDone/' + participationCode);
                const surveyCompletedData = surveyCompletedResult;
                setState(prevState => ({
                    ...prevState,
                    surveyCompleted: surveyCompletedData
                }))
            }
            else {
                setState(prevState => ({
                    ...prevState,
                    surveyCompleted: 0
                }))
            }


        fetch('/api/overviewbtnText')
            .then(response => response.json())
            .then(result => setState(prevState => ({
                ...prevState,
                btnSend: result
            }))).catch(console.log);
    }, [surveyCode]);

    const sendTextAnswer = async () => {
        try {
            let body = [];
            for (let i = 0; i < answerSet.length; i++) {
                body.push({
                    "question_id": answerSet[i].question_id,
                    "questionset_id": answerSet[i].questionset_id,
                    "answer_id": answerSet[i].questionTypeId===1?answerSet[i].answerValue: answerSet[i].answerValue==='Kann/Möchte ich nicht beantworten'?-1:0,
                    "survey_id": answerSet[i].survey_id,
                    "token": answerSet[i].token,
                    "question_type_id": answerSet[i].questionTypeId,
                    "answer_text": answerSet[i].questionTypeId===1? '': answerSet[i].answerValue
                });
            }
            if(GlobalSettings.debugMode==='on')
                console.log(body);
            const response = await fetch("/api/closedanswers", {
                method: "POST",
                headers: { "Content-type": "application/json" },
                body: JSON.stringify(body)
            });
            console.log(response);

            const invalidate = fetch("/api/invalidateSession/" + participationCode).then(response => response.json())
            .then(result => this.setState({
                btnSend: result
            })).catch(console.log);
        } catch (err) {
            console.log(err.message);
        }
    };
   

    if (state.completeSet.length === 0) {
        return null;
    }

    if (valid === false ) {
        return (
            <div>
                <div >
                    <div className="headLine_3"><div className="head_Text2">Fehler: Ungültiger Token</div></div>
                    <div className="orangeLine"></div>
                </div>
                <div className="containerBody">
                    <div className="body2">Bitte kehren Sie zur Startseite zurück, um einen gültigen Token einzugeben.</div>   
                    <img src={pens} className="pens_err" alt='pens'></img>
                </div>
                <div className="container_Footer">
                    <div className="footer_Line">
                        <Link to="/"><button className="btnToSurvey">Zur Startseite</button></Link>
                    </div>
                </div>
            </div>
        );
    } else {
        return (
            <div>
                <div>
                    <PageHeader headerText={surveyTitle} surveyName={surveyName} mode={surveyMode}/>
                </div> 
                <div className="bubbleSurroundings">
                <div className="questionBodyOverview">
                    <div className="bubbleInactiveOverview"></div>
                    <div className="bubbleActiveOverview">
                        <div className="bubbleTextContentOverview">
                            <ResultTable data={answerSet} />
                        </div>
                    </div>
                    <div className="bubbleInactiveOverview"></div>
                    
                </div>
                <div className="sendAnswers">
                        {isButtonDisabled ? (
                                <p>Im Preview-Modus können die Antworten nicht gespeichert werden</p>
                            ) : (
                                <Link to="/exit">
                                    <button className="btnOverview" onClick={sendTextAnswer}>{state.btnSend[0]?.text}</button>
                                </Link>
                            )}
                            <div/>
                        </div>
                        </div>
                <PageFooter progress={100} />
            </div>
        );
    }
};

export default Overview;
